import Vue from 'vue';
import Vuex from 'vuex';

import { state } from './state';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';
import { agencyProfiles } from './modules/agencyProfiles/index';
import { contactRequests } from './modules/contactRequests/index';
import { integrationPartners } from './modules/integrationPartners/index';
import { matchmakingRequests } from './modules/matchmakingRequests/index';
import { ourPublicProfiles } from './modules/ourPublicProfiles/index';
import { publicProfilesShowcase } from './modules/ourPublicProfiles/publicProfilesShowcase';
import { reviews } from './modules/reviews/index';
import { settings } from './modules/settings/index';
import { userAccount } from './../userAccount';

Vue.use(Vuex);

export default {
  state,
  getters,
  mutations,
  actions,
  modules: {
    agencyProfiles,
    contactRequests,
    integrationPartners,
    matchmakingRequests,
    reviews,
    ourPublicProfiles,
    settings,
    userAccount,
    publicProfilesShowcase,
  },
};
